define('areas/home/viewmodels/datatile',["require", "exports", "plugins/router", "areas/home/services/livetilecache"], function (require, exports, Router, Cache) {
    "use strict";
    var DataTileViewModel = (function () {
        //#region ctor
        function DataTileViewModel(node) {
            this.data = null;
            this._node = node;
            this.title = this._node.name;
            this.color = this._node.color || null;
            this.data = this.getLoadingStatusData();
            ko.track(this, ["title", "data", "color"]);
        }
        //#endregion
        DataTileViewModel.prototype.onRendered = function (elements) {
            var _this = this;
            if (this._node.datakey == null || this._node.datakey.length === 0)
                return;
            var cache = new Cache();
            cache.request(this._node.datakey, function (data) { return _this.parseData(data); });
        };
        //#endregion
        DataTileViewModel.prototype.execute = function (data) {
            var app = this._node.application;
            if (!app.embedApp) {
                var externalLink = app.link;
                if (externalLink != null) {
                    window.open(externalLink, "_blank");
                }
            }
            else {
                if (this._node.children.length > 0)
                    Router.navigate(this._node.uri.absolute);
                Router.navigate(data.url);
            }
        };
        DataTileViewModel.prototype.parseData = function (data) {
            this._item = data;
            if (this._item != null)
                this.data = JSON.parse(this._item.jsonContent);
            if (this._item == null)
                this.data = this.getDefaultData();
        };
        //private loadData(datakey: string): void {
        //	var that = this;
        //	var channel = new Http.Channel();
        //	channel.getData("/api/tiles/" + datakey, Http.ServiceTarget.portalApi)
        //		.then((result) => {
        //			that._item = result;
        //			if (that._item != null) that.data = JSON.parse(that._item.jsonContent);
        //			if (that._item == null) that.data = that.getDefaultData();
        //		})
        //		.fail((reason: any) => {
        //			Trace.traceError("Fehler beim Laden der Detaildaten: " + reason, null, datakey, true);
        //		});
        //}
        DataTileViewModel.prototype.getDefaultData = function () {
            var tileMessage = $.t("app:modules.home.tiledata_noData", { ifMissing: "Keine Daten" });
            return {
                showTitle: false,
                parts: [
                    {
                        type: "icon"
                    },
                    {
                        type: "nodata",
                        data: {
                            message: tileMessage,
                            icon: "fa-truck"
                        }
                    }
                ]
            };
        };
        DataTileViewModel.prototype.getLoadingStatusData = function () {
            return {
                showTitle: false,
                parts: [
                    {
                        type: "icon"
                    },
                    {
                        type: "nodata",
                        data: {
                            message: "Lade...",
                            icon: "commenting-o"
                        }
                    }
                ]
            };
        };
        DataTileViewModel.prototype.runWorker = function () {
            var _this = this;
            if (typeof (Worker) !== "undefined") {
                var w = new Worker("app/areas/home/workers/sampleworker.js");
                w.onmessage = function (ev) {
                    _this.data = ev.data;
                    w.terminate();
                };
                w.postMessage("loadData");
            }
        };
        return DataTileViewModel;
    }());
    return DataTileViewModel;
});

